import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { EmptyState, PageHeader } from '../components/UI';
import WhatsAppInbox from '../components/WhatsAppInbox';
import { api } from '../lib/api';

export default function WhatsAppInboxPage(){
  const[params]=useSearchParams();
  const[provider,setProvider]=useState(null);
  const[loading,setLoading]=useState(true);
  const[error,setError]=useState('');

  const load=useCallback(async()=>{
    setLoading(true);setError('');
    try{
      const body=await api('/api/whatsapp');
      setProvider(body.provider||{});
    }catch(err){
      setError(err.message||'WhatsApp status could not be loaded.');
      setProvider({});
    }finally{
      setLoading(false);
    }
  },[]);

  useEffect(()=>{load();},[load]);

  return <section className="whatsapp-inbox-page">
    <PageHeader
      eyebrow="Communications"
      title="WhatsApp Inbox"
      description="Shared WhatsApp conversations, unread messages, staff ownership, notifications and call activity."
      actions={<button className="button secondary govuk-button govuk-button--secondary" type="button" onClick={load} disabled={loading}><RefreshCw size={15}/>Refresh status</button>}
    />
    {error&&<div className="operation-notice error">Error: {error}</div>}
    {loading&&!provider?<EmptyState title="Loading WhatsApp Inbox" body="Opening the shared WhatsApp conversation workspace…"/>:<WhatsAppInbox provider={provider||{}} initialPhone={params.get('phone')||''} initialCustomerId={params.get('customer')||''}/>}
  </section>;
}
